import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { authStore } from "../stores";
import { afd_top_tool_bar_foodangel_logo, top_menu_bar_log_in_status, top_menu_bar_log_out_status, top_tool_bar_menu_button } from "../imgs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MyDrawer } from "./MyDrawer";


const HeaderView = observer(
  () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);


    const showDrawer = () => {
      setOpen(true);
    };

    const onClose = () => {
      setOpen(false);
    };
    const onLogin = () => {
      if(!authStore.loggedIn ){
        navigate('/login')

      }
    }

    return (
      <div
        className="mx-[10px] flex h-[85px] bg-[white]"
        style={{
          borderRadius: 10,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* 图片入口使用按钮，键盘和屏幕阅读器也能操作。 */}
        <button type="button" aria-label={t('drawer.home')} onClick={() => navigate('/')}>
        <img
          className="h-[45px] cursor-pointer pl-[15px]"
          src={afd_top_tool_bar_foodangel_logo}
          alt=""
        />
        </button>
        <div className="flex pr-[20px]"
          style={{
            alignItems: 'center',
          }}
        >

          <button type="button" aria-label={t(authStore.loggedIn ? 'drawer.my_record' : 'drawer.login')} onClick={() => authStore.loggedIn ? navigate('/my-record') : onLogin()}>
          <img
            className="h-[32px] cursor-pointer pr-[10px]"
            src={authStore.loggedIn ? top_menu_bar_log_in_status : top_menu_bar_log_out_status}
            alt=""
          />
          </button>
          <button type="button" aria-label={t('drawer.open_menu')} onClick={showDrawer}>
          <img
            className="h-[23px] cursor-pointer"
            src={top_tool_bar_menu_button}
            alt=""
          />
          </button>
        </div>
        <MyDrawer open={open} onClose={onClose} />

      </div>
    );
  }
)

export default HeaderView;
